import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { jwtDecode } from "jwt-decode";

@Injectable({
  providedIn: 'root'
})
export class AuthStateService {

  router = inject(Router);

  setLoggedInUser(value: any): void {
    localStorage.setItem('loggedInUser', JSON.stringify(value))
  }

  setAuthTokenInfo(value: any): void {
    localStorage.setItem('authTokenInfo', JSON.stringify(value))
    // Store customer_id separately for easy access
    if (value && value['customer_id']) {
      localStorage.setItem('customerId', value['customer_id'].toString());
    }
  }

  getCustomerId(): string | null {
    return localStorage.getItem('customerId');
  }

  getAuthTokenInfo(): any {
    const storedToken = localStorage.getItem('authTokenInfo');
    return storedToken ? JSON.parse(storedToken) : null;
  }

  getLoggedInUser(): any {
    const storedUser = localStorage.getItem('loggedInUser');
    return storedUser ? JSON.parse(storedUser) : null;
  }

  removeAuthTokenInfo(): void {
    localStorage.removeItem('authTokenInfo')
  }

  removeUser(): void {
    localStorage.removeItem('loggedInUser');
  }

  getDecodedAccessToken(token: string): any {
    try {
      return jwtDecode(token);
    } catch (error) {
      return null;
    }
  }

  isAuthenticated(): boolean {
    return (localStorage.getItem('loggedInUser') !== null) ? true : false;
  }

  checkUserPermission(permission: string): boolean {
    if (!permission) {
      return true; // Allow access if no permission is specified
    }
    if (this.getLoggedInUser()['realm_access']['roles'].includes(permission)) {
      return true;
    } else {
      return false;
    }
  }

  clearStorage(): void {
    localStorage.clear();
  }

  logout(){
    this.clearStorage();
    this.router.navigate(['/web-purchases']);
  }

}
